import markPannel from './RightChildPannel/markPannel.vue'
import monitorPannel from './RightChildPannel/monitorPannel.vue'
import noticePannel from './RightChildPannel/noticePannel.vue'
import portPannel from './RightChildPannel/portPannel.vue'
import wharfPannel from './RightChildPannel/wharfPannel.vue'
import gastPannel from './RightChildPannel/gastPannel.vue'
import waterlevelPannel from './RightChildPannel/waterlevelPannel.vue'
import allPannel from './RightChildPannel/allPannel.vue'
import bridgrPannel from './RightChildPannel/bridgrPannel.vue'
import shipPannel from './RightChildPannel/shipPannel.vue'
import rescuePannel from './RightChildPannel/rescuePannel.vue'
import levelPannel from './RightChildPannel/levelPannel.vue'
import scalePannel from './RightChildPannel/scalePannel.vue'
import videoIhg from '../../../assets/hangdao_video.png'
import biaoIhg from '../../../assets/hangbiao.png'
import notice from '../../../assets/hang_notice.png'
import sandbarPannel from './RightChildPannel/sandbarPannel.vue'

/** 控件按钮  */
export const widgetBtnList = [
  {
    key: 'qb',
    name: '全部',
    show: false,
    picture: '',
    com: allPannel,
  },
  {
    key: 'sp',
    name: '视频',
    show: true,
    picture: videoIhg,
    com: monitorPannel,
  },
  {
    key: 'hb',
    name: '航标',
    show: true,
    picture: biaoIhg,
    com: markPannel,
  },
  {
    key: 'sw',
    name: '水位',
    show: true,
    picture: '',
    com: levelPannel,
    position: 'bottom', // 标识显示在底部
    disabled: true,
  },
  {
    key: 'cd',
    name: '尺度',
    show: true,
    picture: '',
    com: scalePannel,
    position: 'bottom', // 标识显示在底部
  },
  {
    key: 'tg',
    name: '通告',
    show: true,
    picture: notice,
    com: noticePannel,
  },
  {
    key: 'gk',
    name: '港口',
    show: false,
    picture: '',
    com: portPannel,
  },
  {
    key: 'mt',
    name: '码头',
    show: false,
    picture: '',
    com: wharfPannel,
  },
  {
    key: 'jyz',
    name: '加油站',
    show: false,
    picture: '',
    com: gastPannel,
  },
  {
    key: 'swz',
    name: '水位站',
    show: false,
    picture: '',
    com: waterlevelPannel,
  },
  {
    key: 'sjz',
    name: '搜救站',
    show: false,
    picture: '',
    com: rescuePannel,
  },
  {
    key: 'ql',
    name: '桥梁',
    show: false,
    picture: '',
    com: bridgrPannel,
  },
  {
    key: 'cz',
    name: '船只',
    show: false,
    picture: '',
    com: shipPannel,
  },
  {
    key: 'sz',
    name: '沙洲',
    show: false,
    picture: '',
    com: sandbarPannel,
  },
]

import overviewCom from './LeftChildPannel/overviewCom.vue'
/** 左侧面板导航类型 */
export const viewNavList = [
  {
    key: 'zl',
    name: '总览',
    com: overviewCom,
  },
  {
    key: 'hd',
    name: '航道',
  },
  {
    key: 'cb',
    name: '船舶',
  },
  {
    key: 'gz',
    name: '过闸',
  },
]
